<div class="dialog-wrapper">
  <p class="emoji-gift-cone">🎉</p>
  <h1 class="welcome-text">{{'signup-success.Welcome' | translate}}</h1>
  <p class="congrats-text">{{'signup-success.Congratulations' | translate}} <br /><br /></p>
  <ion-button expand="block" color="medium" class="capsule-btn" type="submit" (click)="closeME()">
    {{'signup-success.started' | translate}} </ion-button>
</div>